export default __webpack_public_path__ + "static/media/Core-Values-04.a3458b42.png";